import { ScrollArea } from "@/components/ui/scroll-area";
import { format } from "date-fns";

interface ActivityListProps {
  logs: any[];
  isLoading: boolean;
}

export function ActivityList({ logs, isLoading }: ActivityListProps) {
  const formatActivityType = (type: string) => {
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <ScrollArea className="h-[600px] pr-4">
      {isLoading ? (
        <div className="flex items-center justify-center p-4">
          Loading activity logs...
        </div>
      ) : (
        <div className="space-y-2">
          {logs?.map((log) => (
            <div
              key={log.log_id}
              className="flex items-center justify-between py-2 border-b border-border text-sm"
            >
              <div className="flex items-center gap-2">
                <span className="font-medium">
                  {log.creators?.nick_name 
                    ? `${log.creators.nick_name} / ${log.creators.name} ${log.creators.surname}`
                    : `${log.creators?.name} ${log.creators?.surname}`}
                </span>
                <span className="text-muted-foreground">
                  {formatActivityType(log.activity_type)}
                </span>
              </div>
              <span className="text-muted-foreground">
                {log.created_at && format(new Date(log.created_at), "PP p")}
              </span>
            </div>
          ))}
        </div>
      )}
    </ScrollArea>
  );
}